import { useLazyQuery } from '@apollo/client';
import { GET_REPORTS } from '@bechtel/client-gql';
import { ReportInput, PagingInput, ReportList } from '@bechtel/types';

export function useReportList(fetchFromNetwork?: boolean) {
  const response = useLazyQuery<
    { projectReports: ReportList },
    {
      input: ReportInput;
      paging: PagingInput;
    }
  >(
    GET_REPORTS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
